<template>
    <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
        <div class="mt-6 flex items-center justify-between px-6">
            <h4>{{ Object.entries(this.data).length === 0 ? $t("new") : $t("update_a") }} {{ $t("room") }}</h4>
            <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"/>
        </div>
        <vs-divider class="mb-0" />
        <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
            <div class="px-6 py-2">
              <p >{{ $t("code") }} <b style="color: #ff6141">*</b> </p>
              <vs-input
                @keyup.enter="submitData"
                :disabled="detail__detail"
                :danger="error.code || all_errors.code.length ? true : false"
                v-model="input.code" class="w-full"/>
              <span v-if="error.code || all_errors.code.length" class="span-text-validation con-text-validation span-text-validation-danger vs-input--text-validation-span">
                <p v-for="(err, io) in all_errors.code" :key="io" style="margin-bottom: 4px !important; font-size: 13px">{{err}}</p>
              </span>

              <p class="mt-5" >{{ $t("name") }} <b style="color: #ff6141">*</b> </p>
              <vs-input
                @keyup.enter="submitData"
                :disabled="detail__detail"
                :danger="error.libelle || all_errors.libelle.length ? true : false"
                v-model="input.libelle" class="w-full"/>
              <span v-if="error.libelle || all_errors.libelle.length" class="span-text-validation con-text-validation span-text-validation-danger vs-input--text-validation-span">
                <p v-for="(err, io) in all_errors.libelle" :key="io" style="margin-bottom: 4px !important; font-size: 13px">{{err}}</p>
              </span>

              <p class="mt-5" >{{ $t("room_capacity") }} <b style="color: #ff6141">*</b> </p>
              <vs-input-number class="ml-0" v-model="input.capacite" />
              <span v-if="error.capacite || all_errors.capacite.length" class="span-text-validation con-text-validation span-text-validation-danger vs-input--text-validation-span">
                <p v-for="(err, io) in all_errors.capacite" :key="io" style="margin-bottom: 4px !important; font-size: 13px">{{err}}</p>
              </span>

            </div>
        </VuePerfectScrollbar>
        
        <div v-if="!detail__detail" class="flex flex-wrap items-center p-6" slot="footer">
            <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">{{ $t("Submit") }}</vs-button>
            <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">{{ $t("Cancel") }}</vs-button>
        </div>
    </vs-sidebar>
</template>

<script>
// const libelle_default = 'Salle de '
let base_self = ''
const input_tempon = {
  id: null,
  libelle: '',
  code: '',
  is_active: true,
  capacite: ''
}

const initialNoError_tempon = {}
const error_tempon = {}
const all_errors_tempon = {}

const keys = Object.keys(input_tempon)
const length = keys.length
for (let i = 0; i < length; i++) {
  initialNoError_tempon[keys[i]] = false
  error_tempon[keys[i]] = false
  all_errors_tempon[keys[i]] = []
}

import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
  components: {VuePerfectScrollbar},
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      initialNoError: JSON.parse(JSON.stringify(initialNoError_tempon)),
      error: JSON.parse(JSON.stringify(error_tempon)),
      all_errors: JSON.parse(JSON.stringify(all_errors_tempon)),
      input: JSON.parse(JSON.stringify(input_tempon)),
      input1: JSON.parse(JSON.stringify(input_tempon)),
      detail__detail: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
        }
      }
    },
    isFormValid () {
      let is_valide = true
      if (!this.input.libelle || this.input.libelle === '') is_valide = false
      if (!this.input.code || this.input.code === '') is_valide = false
      if (!this.input.capacite || this.input.capacite === '') is_valide = false
      return is_valide
    }
  },
  methods: {
    verification_capacite  () {
      const capacite = base_self.$t('The_room_capacity_is_required')
      if (!base_self.initialNoError.capacite) return false
      if (base_self.input.capacite.length === 0) {
        base_self.all_errors.capacite.push(capacite)
      } else {
        base_self.all_errors.capacite = base_self.all_errors.capacite.filter(e => e !== capacite)
      }
    },
    verification_libelle  () {
      const libelle = base_self.$t('The_name_is_required')
      if (!base_self.initialNoError.libelle) return false
      if (base_self.input.libelle.length === 0) {
        base_self.all_errors.libelle.push(libelle)
      } else {
        base_self.all_errors.libelle = base_self.all_errors.libelle.filter(e => e !== libelle)
      }
    },
    verification_code  () {
      const code = base_self.$t('The_code_is_required')
      if (!base_self.initialNoError.code) return false
      if (base_self.input.code.length === 0) {
        base_self.all_errors.code.push(code)
      } else {
        base_self.all_errors.code = base_self.all_errors.code.filter(e => e !== code)
      }
    },
    async submitData () {
      if (!base_self.isFormValid) {
        window.getESM.error(base_self.$t('The_form_is_invalid'))
        return
      }
      
      const input = JSON.parse(JSON.stringify(this.input))
      
      if (!input.id) {     
        console.log('post entrer : ')
        console.log('post entrer : ')
        console.log('post entrer : ')
        console.log('post entrer : ')
        console.log('post entrer : ')
        console.log('post entrer : ')
        console.log('post entrer : ')
        base_self.$http.post(`${base_self.$store.state.route_for_esm}Salle`, input)
          .then((response) => { 
            window.getESM.success(base_self.$t('The_room_is_added_successfully'), response)
            this.$emit('closeSidebar')
            this.initValues()
          })
          .catch((error) => { 
            console.log('error: ', error)
          })

      } else if (input.id) {
        console.log('put entrer : ', input)
        base_self.$http.put(`${base_self.$store.state.route_for_esm}Salle`, input)
          .then((response) => { 
            console.log('response: ', response)
            console.log('response: ', response)
            console.log('response: ', response)
            console.log('response: ', response)
            window.getESM.success(base_self.$t('The_room_is_changed_successfully'), response)
            this.$emit('closeSidebar')
            this.initValues()
          })
          .catch((error) => { 
            console.log('error.data: ', error.data)
            console.log('error: ', error)
          })
      }
    },
    initValues () {
      base_self.initialNoError = JSON.parse(JSON.stringify(initialNoError_tempon))
      base_self.input = JSON.parse(JSON.stringify(input_tempon))
      base_self.input1 = JSON.parse(JSON.stringify(input_tempon))
      base_self.detail__detail = false
    }
  },
  watch: {
    input: {
      handler  () {
        if (base_self.input1.capacite !== base_self.input.capacite) {
          base_self.initialNoError.capacite = true
          base_self.verification_capacite()
        }

        if (base_self.input1.libelle !== base_self.input.libelle) {
          base_self.initialNoError.libelle = true
          base_self.verification_libelle()
        }

        if (base_self.input1.code !== base_self.input.code) {
          base_self.initialNoError.code = true
          
          // base_self.input.libelle = libelle_default + base_self.input.code
          base_self.verification_code()
        }

        base_self.input1 = JSON.parse(JSON.stringify(base_self.input))
      },
      deep: true
    },
    async isSidebarActive () {
      this.initValues()
      if (base_self.data && base_self.data.id) {
        base_self.input1 = JSON.parse(JSON.stringify(base_self.data))
        base_self.input = JSON.parse(JSON.stringify(base_self.data))
      }
    }
  },
  created () {
    base_self = this
    base_self.initValues()
  }
}
</script>

<style lang="scss" scoped>
  .add-new-data-sidebar {
      ::v-deep .vs-sidebar--background {
          z-index: 52010;
      }

      ::v-deep .vs-sidebar {
          z-index: 52010;
          width: 400px;
          max-width: 90vw;

          .img-upload {
              margin-top: 2rem;

              .con-img-upload {
                  padding: 0;
              }

              .con-input-upload {
                  width: 100%;
                  margin: 0;
              }
          }
      }
  }

  .scroll-area--data-list-add-new {
      // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
      height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
      
  }
</style>

<style>
[dir] .vs__dropdown-toggle {
  border-radius: 20px;
}

[dir] .vdp-datepicker input {
  border-radius: 20px;
}
</style>
